import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'pciLayoutConta'

const Get = (pciID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/pci/${pciID}`, data, config)
const GetAllByAccount = (accountID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/conta/${accountID}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const CreateAt = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/at`, data, config)

const PCILayoutContaRepository = {
  Get,
  GetAllByAccount,
  Create,
  CreateAt
}

export default PCILayoutContaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pcilayoutconta.js